import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Typography, Button, LinearProgress } from '@material-ui/core';
import '../styles/Globales.scss';
import '../styles/Comprobante.scss';
import '../styles/CuadroResumen.scss';
import ViewConstants from '../utils/ViewConstants';
import appStore from '../stores/AppStore';
import CuadroResumenComponent from './utils/CuadroResumenComponent';
import PaginadorComponent from './utils/PaginadorComponent';

const component = observer(
  class IniciarSolicitud extends Component {
    constructor(props) {
      super(props);
      this.state = {
        paginaActiva: 1,
      };
    }

    onPageChange = (event, page) => {
      this.setState({ paginaActiva: page }, () => {
        appStore.cargarSolicitudesCliente(null, this.state.paginaActiva - 1);
      });
    };

    iniciarNuevaPortabilidad = () => {
      appStore.generateDataLayer({ eventAction: 'step_8', eventLabel: 'nueva_portabilidad' });
      appStore.changeNavigation(ViewConstants.ETAPA_SELECCION_BANCO);
    };
    render() {
      return (
        <div className="contenedorPrincipal">
          <div className="paso">
            <div>
              <Typography className="tituloBR">Revisa aquí el estado de tus solicitudes vigentes</Typography>
            </div>
          </div>
          <LinearProgress variant="determinate" color="secondary" value={3 * (100 / 6)} className="barraProgreso" />
          <div className="cajasResumen">
            {appStore.solicitudesCliente.map((item) => {
              return <CuadroResumenComponent solicitud={item} key={item.id} />;
            })}
          </div>
          {appStore.totalRegistrosSolicitudes > appStore.PAGE_SIZE && (
            <div className="paginadorContenedor">
              <PaginadorComponent paginaActiva={this.state.paginaActiva} onChange={this.onPageChange} />
            </div>
          )}
          <div className="botones">
            <Button className="btnRipley" onClick={this.iniciarNuevaPortabilidad}>
              Iniciar nueva portabilidad{' '}
            </Button>
          </div>
        </div>
      );
    }
  }
);

export default component;
